import React, { FC, Fragment } from 'react';
import { NextLink, useTranslate } from '~/i18n';
import cn from 'classnames';
import styles from './styles.module.css';
import { AngelLeftIcon, AngelRightIcon } from '~/svgs/common';
import { BreadcrumbJsonLd } from 'next-seo';
import { ItemListElements } from 'next-seo/lib/jsonld/breadcrumb';
import { BASE_URL } from '~/utils/theme';

export type BreadcrumbItem = {
   name: string;
   href: string;
   disabled?: boolean;
   className?: string;
   hide?: boolean;
};
interface BreadcrumbProps extends React.HTMLProps<HTMLDivElement> {
   items: BreadcrumbItem[];
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items, ...props }) => {
   const { dir } = useTranslate();

   const breadcrumb: ItemListElements[] =
      items?.map(({ name, href }, idx) => {
         return {
            // Remove all ["], rich snippet breaks with ["]
            name: name.replace(/"/g, ''),
            position: idx + 1,
            item: BASE_URL + href,
         };
      }) || [];

   return (
      <div {...props}>
         <BreadcrumbJsonLd itemListElements={breadcrumb} />
         <ul className={styles['breadcrumb']}>
            {items?.map(({ name, disabled, href, className, hide }, idx) => {
               if (hide) return null;
               return (
                  <li
                     key={idx}
                     className={cn('flex items-center leading-none capitalize', className)}>
                     {disabled ? (
                        <span>{name}</span>
                     ) : (
                        <Fragment>
                           <NextLink href={href}>
                              <span className="block">{name}</span>
                           </NextLink>
                        </Fragment>
                     )}

                     {idx !== items.length - 1 ? (
                        <div>
                           {dir === 'rtl' ? (
                              <AngelLeftIcon className="transform scale-75" />
                           ) : (
                              <AngelRightIcon className="transform scale-75" />
                           )}
                        </div>
                     ) : null}
                  </li>
               );
            })}
         </ul>
      </div>
   );
};
Breadcrumb.displayName = 'Breadcrumb';
export default React.memo(Breadcrumb);
